// extracted by mini-css-extract-plugin
export default {"root":"_1KonCqQ","description":"foAkb18","title":"+nWLuGI","mainInfo":"_1HxlQyp","logoContainer":"zGLHm+d","cell":"ODuDlwn"};